import React, { useEffect, useState } from "react";
import { Navbar, Container, Nav, NavDropdown } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import logo from "../../assets/logo.svg";

const activeStyle = {
  color: "white",
  borderBottom: "underline 0.2rem solid white",
};

const dropdownItemStyle = {
  color: "black",
};

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);

  const handleScroll = () => {
    const scrollPosition = window.scrollY;
    setIsScrolled(scrollPosition > 0);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      className={`sticky-top ${isScrolled ? "shadow" : ""} p-0`}
      style={{
        background: `rgba(217, 0, 27)`,
        borderBottom: `${
          isScrolled ? "0.01px solid rgba(217, 0, 27, 0.2)" : ""
        }`,
      }}
      variant="dark"
    >
      <Container className="d-flex justify-content-between ">
        <NavLink to="/" className="text-white d-block">
          <Navbar.Brand className="d-flex justify-content-between align-items-center mt-1">
            <div style={{ width: "3rem" }}>
              <img
                src={logo}
                alt="Paulines"
                style={{ width: "100%" }}
                loading="lazy"
              />
            </div>
          </Navbar.Brand>
        </NavLink>

        <Navbar.Toggle aria-controls="responsive-navbar-nav" style={{ borderColor: '#d9001b', color: '#d9001b' }} />

        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto"></Nav>
          <Nav fill defaultActiveKey="/home">
            <NavLink
              to="/"
              className="text-white d-block py-2 px-3"
              activeClassName="active"
              activeStyle={activeStyle}
            >
              Home
            </NavLink>
            <NavDropdown
              title="Who We Are"
              id="collapsible-nav-dropdown"
              style={{ position: "relative", zIndex: 1 }}
            >
              <NavLink
                to="/founders"
                className="d-block py-2 px-3"
                activeClassName="active"
                activeStyle={activeStyle}
                style={dropdownItemStyle}
              >
                Founders
              </NavLink>
              <NavLink
                to="/history"
                className="d-block py-2 px-3"
                activeClassName="active"
                activeStyle={activeStyle}
                style={dropdownItemStyle}
              >
                Our History
              </NavLink>
              <NavLink
                to="/spirituality"
                className="d-block py-2 px-3"
                activeClassName="active"
                activeStyle={activeStyle}
                style={dropdownItemStyle}
              >
                Our Spirituality
              </NavLink>
              <NavLink
                to="/mission"
                className="d-block py-2 px-3"
                activeClassName="active"
                activeStyle={activeStyle}
                style={dropdownItemStyle}
              >
                Pauline Mission
              </NavLink>
            </NavDropdown>
            <Nav.Link
              href="https://shop.paulinesafrica.org"
              target="_blank"
              rel="noopener noreferrer"
            >
              Online Shop
            </Nav.Link>
            <Nav.Link
              href="https://young.paulinesafrica.org"
              target="_blank"
              rel="noopener noreferrer"
            >
              Vocations
            </Nav.Link>
            <Nav.Link 
              href="https://shop.paulinesafrica.org/donations"
              target="_blank" 
              rel="noopener noreferrer">Donations</Nav.Link>
            <NavDropdown
              title="Cooperators"
              id="collapsible-nav-dropdown"
              style={{ position: "relative", zIndex: 1 }}
            >
              <NavLink
                to="/cooperators"
                className="d-block py-2 px-3"
                activeClassName="active"
                activeStyle={activeStyle}
                style={dropdownItemStyle}
              >
                Cooperators
              </NavLink>
              <NavLink
                to="/cooperators-mission"
                className="d-block py-2 px-3"
                activeClassName="active"
                activeStyle={activeStyle}
                style={dropdownItemStyle}
              >
                Mission
              </NavLink>
              <NavLink
                to="/cooperators-spirituality"
                className="text-white d-block py-2 px-3"
                activeClassName="active"
                activeStyle={activeStyle}
                style={dropdownItemStyle}
              >
                Spirituality
              </NavLink>
            </NavDropdown>
            <NavDropdown
              title="Events"
              id="collapsible-nav-dropdown"
              style={{ position: "relative", zIndex: 1 }}
            >
              <NavLink
                to="/gallery/past"
                className="d-block py-2 px-3"
                activeClassName="active"
                activeStyle={activeStyle}
                style={dropdownItemStyle}
              >
                Past Events
              </NavLink>
              <NavLink
                to="/gallery/upcoming"
                className="d-block py-2 px-3"
                activeClassName="active"
                activeStyle={activeStyle}
                style={dropdownItemStyle}
              >
                Upcoming Events
              </NavLink>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
